import React from 'react';
import SubscriptionList from '@components/subscription/list/SubscriptionList';
import UpsellingBanner from '@components/subscription/list/UpsellingBanner';
import { useAtomValue } from 'jotai';
import { haveSubjectForTrialAtom } from '@atom/globalQueryAtom';

const SubscriptionDashboard = () => {
  const haveSubjectForTrial = useAtomValue(haveSubjectForTrialAtom);

  return (
    <div className={'pb-4'}>
      <p
        className={
          'text-neutral-whiteboard text-lg font-semibold max-lg:hidden mb-4 leading-normal'
        }
      >
        Subjects
      </p>
      <SubscriptionList />
      {haveSubjectForTrial && <UpsellingBanner />}
    </div>
  );
};

export default SubscriptionDashboard;
